/* =========================================================================
   PÁSATE A LO NATURAL · interactions
   ========================================================================= */
(() => {
  'use strict';

  // -------------------- Reveal on scroll --------------------
  const revealObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        revealObserver.unobserve(e.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('.reveal').forEach(el => revealObserver.observe(el));

  // -------------------- Strike chem-list-1 (sequential when in view) --------------------
  const chemList1 = document.getElementById('chem-list-1');
  if (chemList1) {
    const items = [...chemList1.querySelectorAll('li')];
    const triggerOnce = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          // do NOT auto-strike here — keep first list intact (Acto I just shows the recipe)
          triggerOnce.disconnect();
        }
      });
    }, { threshold: 0.4 });
    triggerOnce.observe(chemList1);
  }

  // -------------------- Cinematic scenes (5 escenas) --------------------
  const scenes = document.getElementById('scenes');
  if (scenes) {
    const sceneEls = [...scenes.querySelectorAll('.scene')];
    const stepEls  = [...scenes.querySelectorAll('.scene-step')];

    function activateScene(idx) {
      sceneEls.forEach((s, i) => s.classList.toggle('active', i === idx));
    }
    activateScene(0);

    const sceneObs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          const idx = parseInt(e.target.dataset.scene, 10);
          activateScene(idx);
        }
      });
    }, { threshold: 0.5 });
    stepEls.forEach(s => sceneObs.observe(s));
  }

  // -------------------- Number counters --------------------
  const counterObserver = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        const el = e.target;
        const target = parseInt(el.dataset.count, 10);
        const duration = 1400;
        const start = performance.now();
        const initial = 0;
        function tick(now) {
          const t = Math.min(1, (now - start) / duration);
          const eased = 1 - Math.pow(1 - t, 3);
          el.textContent = Math.round(initial + (target - initial) * eased).toLocaleString('es-ES');
          if (t < 1) requestAnimationFrame(tick);
        }
        requestAnimationFrame(tick);
        counterObserver.unobserve(el);
      }
    });
  }, { threshold: 0.4 });
  document.querySelectorAll('[data-count]').forEach(el => counterObserver.observe(el));

  // -------------------- Bach words flourish --------------------
  const bachWords = document.getElementById('bach-words');
  if (bachWords) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          bachWords.classList.add('in');
          obs.unobserve(bachWords);
        }
      });
    }, { threshold: 0.4 });
    obs.observe(bachWords);
  }

  // -------------------- Less bottles purge --------------------
  const lessBottles = document.getElementById('less-bottles');
  if (lessBottles) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          setTimeout(() => lessBottles.classList.add('purged'), 600);
          obs.unobserve(lessBottles);
        }
      });
    }, { threshold: 0.4 });
    obs.observe(lessBottles);
  }
  const lessStrike = document.getElementById('less-strike');
  if (lessStrike) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          setTimeout(() => lessStrike.classList.add('in'), 300);
          obs.unobserve(lessStrike);
        }
      });
    }, { threshold: 0.6 });
    obs.observe(lessStrike);
  }

  // -------------------- Topbar progress + chapter label + dark mode toggle --------------------
  const topbar = document.getElementById('topbar');
  const progressFill = document.getElementById('progress-fill');
  const chapterTag = document.getElementById('chapter-tag');
  const topbarLogo = document.getElementById('topbar-logo');
  const acts = {
    1: 'I · Despertar',
    2: 'II · Verdad incómoda',
    3: 'III · Alternativa',
    4: 'IV · Compromiso',
  };
  const sectionsWithAct = [...document.querySelectorAll('section[data-act]')];
  function onScroll() {
    const docH = document.documentElement.scrollHeight - window.innerHeight;
    const pct = Math.min(100, Math.max(0, (window.scrollY / docH) * 100));
    if (progressFill) progressFill.style.width = pct + '%';

    // determine current section
    const mid = window.scrollY + window.innerHeight * 0.4;
    let currentAct = '1';
    let darkSection = false;
    for (const sec of sectionsWithAct) {
      const top = sec.offsetTop;
      const bottom = top + sec.offsetHeight;
      if (mid >= top && mid < bottom) {
        currentAct = sec.dataset.act;
        const cs = getComputedStyle(sec);
        // dark when section background is the carbon
        if (sec.classList.contains('act-2') || sec.classList.contains('act-2-data') || sec.classList.contains('pact')) {
          darkSection = true;
        }
        break;
      }
    }
    if (chapterTag) chapterTag.textContent = acts[currentAct];
    if (topbar) topbar.classList.toggle('dark', darkSection);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  // -------------------- Pact statements toggle --------------------
  const statementsList = document.getElementById('pact-statements');
  if (statementsList) {
    statementsList.addEventListener('click', (e) => {
      const li = e.target.closest('li');
      if (!li) return;
      li.classList.toggle('checked');
      checkPactReady();
    });
  }

  // -------------------- Signature pad (HiDPI, mobile-friendly) --------------------
  const canvas = document.getElementById('sign-canvas');
  const signWrap = document.getElementById('sign-wrap');
  const signHint = document.getElementById('sign-hint');
  const signClear = document.getElementById('sign-clear');
  let signed = false;
  let drawing = false;
  let lastX = 0, lastY = 0;
  let ctx;

  function setupCanvas() {
    if (!canvas) return;
    const rect = signWrap.getBoundingClientRect();
    const dpr = window.devicePixelRatio || 1;
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    canvas.style.width = rect.width + 'px';
    canvas.style.height = rect.height + 'px';
    ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    ctx.lineCap = 'round';
    ctx.lineJoin = 'round';
    ctx.lineWidth = 2.4;
    ctx.strokeStyle = '#17140f';
  }

  function getPos(e) {
    const rect = canvas.getBoundingClientRect();
    const isTouch = e.touches && e.touches.length > 0;
    const cx = isTouch ? e.touches[0].clientX : e.clientX;
    const cy = isTouch ? e.touches[0].clientY : e.clientY;
    return { x: cx - rect.left, y: cy - rect.top };
  }

  function startDraw(e) {
    e.preventDefault();
    drawing = true;
    const p = getPos(e);
    lastX = p.x; lastY = p.y;
    if (!signed) {
      signed = true;
      if (signHint) signHint.style.display = 'none';
      checkPactReady();
    }
  }
  function moveDraw(e) {
    if (!drawing) return;
    e.preventDefault();
    const p = getPos(e);
    ctx.beginPath();
    ctx.moveTo(lastX, lastY);
    ctx.lineTo(p.x, p.y);
    ctx.stroke();
    lastX = p.x; lastY = p.y;
  }
  function endDraw() { drawing = false; }

  if (canvas && signWrap) {
    setupCanvas();
    window.addEventListener('resize', () => {
      // preserve drawing on resize: snapshot then re-apply
      if (!ctx) { setupCanvas(); return; }
      const tmp = document.createElement('canvas');
      tmp.width = canvas.width; tmp.height = canvas.height;
      tmp.getContext('2d').drawImage(canvas, 0, 0);
      setupCanvas();
      const dpr = window.devicePixelRatio || 1;
      ctx.drawImage(tmp, 0, 0, tmp.width / dpr, tmp.height / dpr);
    });

    canvas.addEventListener('mousedown', startDraw);
    canvas.addEventListener('mousemove', moveDraw);
    window.addEventListener('mouseup', endDraw);
    canvas.addEventListener('touchstart', startDraw, { passive: false });
    canvas.addEventListener('touchmove', moveDraw, { passive: false });
    canvas.addEventListener('touchend', endDraw);
    canvas.addEventListener('touchcancel', endDraw);
  }

  if (signClear) {
    signClear.addEventListener('click', (e) => {
      e.stopPropagation();
      if (ctx && canvas) ctx.clearRect(0, 0, canvas.width, canvas.height);
      signed = false;
      if (signHint) signHint.style.display = 'flex';
      checkPactReady();
    });
  }

  // -------------------- Pact CTA gating + stamp + date --------------------
  const cta = document.getElementById('pact-cta');
  const stamp = document.getElementById('pact-stamp');
  const dateLabel = document.getElementById('pact-date-label');

  function checkPactReady() {
    const checkedCount = statementsList ? statementsList.querySelectorAll('li.checked').length : 0;
    const ready = checkedCount > 0 && signed;
    if (cta) {
      cta.setAttribute('aria-disabled', ready ? 'false' : 'true');
    }
    if (stamp) {
      stamp.classList.toggle('show', ready);
    }
    if (ready && dateLabel) {
      const d = new Date();
      const months = ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
      dateLabel.textContent = `${String(d.getDate()).padStart(2,'0')} · ${months[d.getMonth()]} · ${d.getFullYear()}`;
    }
  }

  if (cta) {
    cta.addEventListener('click', (e) => {
      if (cta.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        // gentle nudge: scroll to statements
        if (statementsList) statementsList.scrollIntoView ? null : null;
        const card = document.querySelector('.pact-card');
        if (card) {
          card.animate(
            [{ transform: 'translateX(0)' }, { transform: 'translateX(-8px)' }, { transform: 'translateX(8px)' }, { transform: 'translateX(0)' }],
            { duration: 320, easing: 'ease-in-out' }
          );
        }
      }
    });
  }

  checkPactReady();
})();
